'use client'

import { Typography, Box, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function Error() {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        px: { xs: 3, md: 8 },
        py: { xs: '50px', md: '100px' }
      }}>
      <Stack spacing={3}>
        <Typography variant='h1' sx={{ textTransform: 'none !important' }}>
          {t('Something Went Wrong')}
        </Typography>
        <Typography>{t('Please Try Again Later')}</Typography>
      </Stack>
    </Box>
  )
}
